import { IconClose, IconTickSingle } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { storeCatalogGift } from "redux/actions";

interface Props {
  catalogId: string | undefined;
  users: any;
}

const CatalogGiftConfirmationModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  catalogId,
  users,
}) => {
  const dispatch = useDispatch();
  const { isFormLoading } = useSelector((state: any) => state.catalogReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleSubmit = () => {
    dispatch(storeCatalogGift(catalogId, { users }, handleCloseModal) as any);
  };

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
      overflowY={"auto"}
      maxWidth={"50vw"}
    >
      <DialogHeader></DialogHeader>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          style={{
            gap: 20,
          }}
        >
          <Text scale={400}>
            Please confirm that the users for sending the gift are correct.
          </Text>
          <Card
            maxHeight={"100%"}
            width={"100%"}
            overflow={"auto"}
            elevation={2}
          >
            <Table>
              <TableHead position={"sticky"} top={0} backgroundColor={"white"}>
                <TableHeadRow>
                  <TableHeadCell>Ancol ID</TableHeadCell>
                  <TableHeadCell>Name</TableHeadCell>
                  <TableHeadCell>Email</TableHeadCell>
                  <TableHeadCell>Phone Number</TableHeadCell>
                  <TableHeadCell>Quantity</TableHeadCell>
                </TableHeadRow>
              </TableHead>
              <TableBody>
                {!users.length ? (
                  <TableBodyRow>
                    <TableBodyCell colSpan={5} textAlign={"center"}>
                      No reward available
                    </TableBodyCell>
                  </TableBodyRow>
                ) : (
                  users.map((user: any) => {
                    return (
                      <TableBodyRow>
                        <TableBodyCell>{user.ancol_id}</TableBodyCell>
                        <TableBodyCell>{user.name}</TableBodyCell>
                        <TableBodyCell>{user.email}</TableBodyCell>
                        <TableBodyCell whiteSpace={"nowrap"}>
                          +62 {user.phone_number.slice(2)}
                        </TableBodyCell>
                        <TableBodyCell>{user.quantity}</TableBodyCell>
                      </TableBodyRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </Card>
        </Box>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15, justifyContent: "center" }}
        >
          <Button
            variant="outline"
            onClick={() => handleCloseModal()}
            icon={IconClose}
            iconPosition={"left"}
            width={200}
            height={45}
            style={{
              color: "white",
              backgroundColor: `${theme.colors.red05}`,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClickCapture={() => handleSubmit()}
            isLoading={isFormLoading}
            onClick={() => {}}
            icon={IconTickSingle}
            iconPosition={"left"}
            width={200}
            height={45}
            style={{
              color: "white",
              backgroundColor: `${theme.colors.green07}`,
            }}
          >
            Confirm
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default CatalogGiftConfirmationModal;
